/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useMemo, useState} from 'react'
import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {KTSVG} from '../../../../../_metronic/helpers'
import {getTypeServicesAll} from '../../../../services/typeServices'
import {SearchInputV3} from '../../../components/SearchInputV3'
import {useToast} from '../../../components/Toats'
import {ModalAddUpdateClient} from '../ModalAddEditTypeService'
import {ModalDeleteTypeService} from '../ModalDeleteTypeService'
import {TableBody} from './TableBody'
import {PaginationTablePlants} from '../../../dashboard/TablePlants/components/Pagination'
import listLayoutStyles from '../../../components/ListTableLayout/listTableLayout.module.css'
import {Loading} from '../../../components/Loadings/loading'

type Props = {
  className: string
  refresh: any
  refreshPage: boolean
  setRefreshPage: any
}

type Paginations = {
  page: number
  limit: number
  total: number
  qtdPages: number
}

type SetPaginations = {
  start: number
  end: number
}

const PAGE_SIZE = 10

const TableTypeServices: React.FC<Props> = ({className, refreshPage}) => {
  const [showCreateAppModal, setShowCreateAppModal] = useState(false)
  const [showCreateAppModalDelete, setShowCreateAppModalDelete] = useState(false)
  const [myTypeService, setMyTypeService] = useState<any | null>(null)
  const [filterName, setFilterName] = useState('')
  const {toggleToast} = useToast()

  const [pagination, setPagination] = useState<Paginations>({
    page: 1,
    limit: PAGE_SIZE,
    total: 0,
    qtdPages: 1,
  })

  const [qtd, setQtd] = useState<SetPaginations>({
    start: 0,
    end: PAGE_SIZE,
  })

  const {
    data: typeServices = [],
    isLoading: typeServiceLoading,
    refetch,
  } = useQuery({
    queryKey: ['getTypeServicesCatalog', filterName, refreshPage],
    queryFn: async () => {
      try {
        return await getTypeServicesAll({
          name: filterName || undefined,
        })
      } catch (error) {
        console.log(error)
        toggleToast('Erro ao buscar os serviços!', 'error')
        return []
      }
    },
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 2,
  })

  const paginatedTypeServices = useMemo(() => {
    if (!Array.isArray(typeServices)) return []
    const start = (pagination.page - 1) * pagination.limit
    return typeServices.slice(start, start + pagination.limit)
  }, [typeServices, pagination.page, pagination.limit])

  useEffect(() => {
    const total = Array.isArray(typeServices) ? typeServices.length : 0
    const qtdPages = Math.max(1, Math.ceil(total / pagination.limit))

    setPagination((prev) => ({
      ...prev,
      total,
      qtdPages,
      page: prev.page > qtdPages ? 1 : prev.page,
    }))
  }, [typeServices, pagination.limit])

  useEffect(() => {
    const total = pagination.total
    const start = total === 0 ? 0 : (pagination.page - 1) * pagination.limit + 1
    const end = Math.min(pagination.page * pagination.limit, total)
    setQtd({start, end})
  }, [pagination.page, pagination.limit, pagination.total])

  useEffect(() => {
    setPagination((prev) => ({...prev, page: 1}))
  }, [filterName])

  return (
    <div className={`${className}`}>
      <div className={`border-0 ${listLayoutStyles.listCardHeader}`}>
        <div className={`${listLayoutStyles.listToolbar} ${listLayoutStyles.listToolbarPanel}`}>
          <div className={listLayoutStyles.listToolbarFilters}>
            <SearchInputV3
              className={`form-control form-control-sm ${listLayoutStyles.listSearch}`}
              placeholder='Buscar serviço por nome'
              setMySearch={setFilterName}
              setPagination={setPagination}
              style={{width: '100%'}}
            />
          </div>

          <div className={`card-toolbar ${listLayoutStyles.listToolbarActions}`}>
            <a
              onClick={(event) => {
                event.preventDefault()
                setMyTypeService(null)
                setShowCreateAppModal(true)
              }}
              href='#'
              className='btn btn-sm btn-light-primary'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Novo Serviço
            </a>
          </div>
        </div>
      </div>

      <div className={`pt-2 ${listLayoutStyles.listTablePanel}`}>
        <div className={`table-responsive ${listLayoutStyles.listTableWrap}`}>
          <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bolder text-muted fs-7 text-uppercase gs-0'>
                <th className='min-w-280px'>Serviço</th>
                <th className='min-w-120px'>R$ Preço</th>
                <th className='min-w-100px text-end'>Ações</th>
              </tr>
            </thead>

            {typeServiceLoading ? (
              <tbody>
                <tr>
                  <td colSpan={3}>
                    <div className='d-flex justify-content-center align-items-center py-10'>
                      <Loading myClass='spinner-border' style={{width: '2.5rem', height: '2.5rem'}} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <TableBody
                typeServices={paginatedTypeServices}
                setMyTypeService={setMyTypeService}
                setShowCreateAppModal={setShowCreateAppModal}
                setShowCreateAppModalDelete={setShowCreateAppModalDelete}
                setShowCreateAppModalDetails={() => {}}
              />
            )}
          </table>
        </div>
      </div>

      <div className={listLayoutStyles.listCardFooter}>
        <PaginationTablePlants
          pagination={pagination}
          setPagination={setPagination}
          qtd={qtd}
        />
      </div>

      <ModalAddUpdateClient
        show={showCreateAppModal}
        id={myTypeService ? myTypeService.id : undefined}
        data={myTypeService ? myTypeService : undefined}
        handleClose={() => {
          setMyTypeService(null)
          setShowCreateAppModal(false)
          refetch()
        }}
      />
      <ModalDeleteTypeService
        show={showCreateAppModalDelete}
        data={myTypeService}
        id={myTypeService ? myTypeService.id : undefined}
        handleClose={() => {
          setMyTypeService(null)
          setShowCreateAppModalDelete(false)
          refetch()
        }}
      />
    </div>
  )
}

export {TableTypeServices}
